// Stempel-Kopplung des Timer-Anwesenheits-Gates (A3): wer „gehen" oder „Pause" stempelt, während der
// Auftrags-Timer läuft, bekommt den Timer automatisch gestoppt & gebucht — bis zum Stempel-Moment, über
// dieselbe Outbox-Garantie wie der manuelle Stopp. Sonst liefe Auftragszeit in Pause/Feierabend weiter,
// genau die Divergenz (Auftragszeit > Anwesenheit), die das Gate verhindert.
import { submitTime, type SubmitResult } from './submitTime'
import { clearTimer, elapsedSeconds, getRunningTimer } from './timerStore'

export interface AutoStopResult {
  orderId: number
  seconds: number
  /** Zustellung der Buchung (null = terminaler Fehler → sichtbar im Dead-Letter, nie still verloren). */
  delivered: Promise<SubmitResult | null>
}

export function autoStopRunningTimer(): AutoStopResult | null {
  const t = getRunningTimer()
  if (!t) return null
  const seconds = elapsedSeconds(t, Date.now())
  clearTimer()
  try {
    window.dispatchEvent(new Event('wf-timer-changed')) // laufende Timer-Anzeigen sofort nachziehen
  } catch {
    // Testumgebung ohne window-Events — der Timer ist trotzdem gestoppt.
  }
  if (seconds < 1) return null
  const delivered = submitTime(t.orderId, seconds, t.startedAt).catch(() => null)
  return { orderId: t.orderId, seconds, delivered }
}
